export default Object.freeze({
  LOCATION: {
    UNASSIGNED: 'unassigned',
    OUT: 'out',
  },
});
